import { type Vec3 } from "../src/data";

export function dist1D(x1: number, x2: number) {
	return (x1 > x2) ? x1 - x2 : x2 - x1;
}

export function dist2D(x1: number, y1: number, x2: number, y2: number) {
	return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
}

export function dist3D({ x: x1, y: y1, z: z1 }: Vec3, { x: x2, y: y2, z: z2 }: Vec3) {
	return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2 + (z1 - z2) ** 2);
}

export function projectDistance(dist: number, z1: number, z2: number) {
	const diff = dist1D(z1, z2);
	return Math.sqrt(dist ** 2 - diff ** 2);
}
